@if (argument) {
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-applications sd-component-wrapper-component
      [applicationData]="argument"
      [layoutTextConfig]="textConfig"
      [twicPicsAutoSize]="!isFirst"
      [brand]="brandCorner"
      (linkClicked)="onClickLink($event)"
    />
  </wc-wrapper>
}
